<script>
import {nextTick} from 'vue';

export default {
    data() {
        return {
            link: null,
            isOpen: false
        }
    }
}
</script>